import React, { useLayoutEffect, useState, useRef } from "react";

/*  NOTES:
 *    >Types of Controls:
 *      ~add
 *      ~calendar
 *      ~clear
 *      ~question (help) [implemented]
 *      ~show/hide pw
 *      ~search
 */

const OneXTextField = ({
  id,
  label = "Label",
  disabled = false,
  readOnly = false,
  type = "text",
  defaultValue,
  dataFormatter=null,
  changeHandler,
  blurHandler,
  errorCode = -1,
  errors = [],
  required = false,
  maskTeaLeaf = false,
  autocomplete = true,

  // These fields control the offset and sizing at various breakpoints
  sm_offset = 0,
  md_offset = 0,
  lg_offset = 0,
  sm_col = 12,
  md_col = 12,
  lg_col = 12,
  // END

  // These fields should only be set if dataFormatter === "custom"
  placeholder = null,
  title = null,
  pattern = null,
  // END

  style = {},
  charLimit = 0

}) => {
  const [value, setValue] = useState(defaultValue);

  const wrapperRef = useRef(null);

  let offset = `${sm_offset > 0 ? `-oneX-offset-${sm_offset} ` : ""}${md_offset > 0 ? `-oneX-offset-md-${md_offset} ` : ""}${lg_offset > 0 ? `-oneX-offset-lg-${lg_offset} ` : ""}`;
  let col = `${sm_col < 12 ? `-oneX-col-${sm_col} ` : ""}${md_col < 12 ? `-oneX-col-md-${md_col} ` : ""}${lg_col < 12 ? `-oneX-col-lg-${lg_col} ` : ""}`;

  const regexEnforcement = (event) => {
    let regex = new RegExp(`[^${pattern}]+`);
    event.target.value = event.target.value.replace(regex, "");
  }
/*
  const charLimitEnforcement = (event) => {
    let value = event.target.value;
    if(value.length > charLimit) {
      event.target.value = value.substring(0, charLimit);
    };
  }
*/
useLayoutEffect(() => {

  const currentRef = wrapperRef.current;

  window.oneX.addElement(currentRef);

  return () => {
    window.oneX.removeElement(currentRef);
  }

}, []); 

  return (
    <div id={`${id}-wrapper-textfield`} ref={wrapperRef} className={`${col}${offset}${errorCode > -1 ? ` -oneX-widget--err` : null}`} style={style}>
      <fieldset className="-oneX-fieldset" id={`${id}-fieldset`}>
        <label
          id={`${id}-label`}
          htmlFor={`${id}-input`}
          className="-oneX-textfield__floatingLabel"
          style={{ overflow: "hidden", whiteSpace: "nowrap", fontSize: "14px" }}
        >
          {label}
        </label>
        <input
          id={`${id}-input`}
          autocomplete = {autocomplete}
          type={type}
          required={required}
          className={maskTeaLeaf? "-oneX-textfield--floating-input tlPrivate":"-oneX-textfield--floating-input"}
          data-formatter={dataFormatter}
          placeholder={placeholder}
          title={title}
          pattern={pattern}
          disabled={disabled}
          readOnly={readOnly}
          aria-invalid={errorCode > -1 ? true : false}
          aria-describedby={errorCode > -1 ? `${id}-error` : null}
          onBlur={(e) => {
            e.preventDefault();
            setValue(e.target.value);
            if (blurHandler) {
              blurHandler(e);
            }
          }}
          onChange={(e) => {
            e.preventDefault();
            if(pattern != null){
              regexEnforcement(e);
            }
            if(charLimit > 0) {
              //charLimitEnforcement(e);
            }
            changeHandler(e);
            setValue(e.target.value);
          }}
          defaultValue={value}
        />
      </fieldset>
      {errorCode > -1 ? (
        <div id={`${id}-error`} className="-oneX-widget__err-text" role="alert" aria-live="assertive">
          <span aria-label="Error"> {errors[errorCode]} </span>
        </div>
      ) : null}
    </div>
  );
};

export default OneXTextField;
